import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SharedModule } from '../../shared/shared.module';
import { StepCommentsPage } from './step-comments';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    StepCommentsPage,
  ],
  imports: [
    IonicPageModule.forChild(StepCommentsPage),
    SharedModule,
    DirectivesModule,
  ],
})
export class StepCommentsPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/operations/step-comments/step-comments.module.ts